// import Detail from '@/components/News/detail';
import Layout from '@/components/Layout';
import dynamic from 'next/dynamic';
const Detail = dynamic(() => import('@/components/Project/DetailProject'));


Detail.getLayout = function getLayout(page) {
    return (
        <Layout webViewMobile={true} web='project_details' >{page}</Layout>
    );
};

export async function getServerSideProps(context) {

    try {
        const res = await fetch(`${process.env.NEXT_PUBLIC_API_SERVER_URL}/app/project/get-detail/${context.params.sort_url}`, {
            headers: {
                'Content-Type': 'application/json',
                locale: context.locale

            }
        });
        const data = await res.json();
        const data_value = data.data.find(it => it.language.sign === context.locale);

        if (!data || data.code !== 200) {
            return {
                notFound: true,
            };
        }

        return {
            props: data_value, // will be passed to the page component as props
        };
    } catch (error) {
        console.log(error);
        return {
            notFound: true,
        };
    }

}
export default Detail